module.exports = __webpack_public_path__ + "static/media/YF03_4.dcc1bce8.jpg";